import { Button, Dialog, DialogActions, DialogContent, DialogTitle } from '@material-ui/core';
import { useBoolean, useRecentGetter } from '@lib/common';
import { useCallback, useEffect, useMemo, useState } from 'react';
// import { useSubject } from '@lib/common/hooks/use-subject';
// import fuzzysort from 'fuzzysort';
// import { useSubscription } from '@lib/common/hooks/use-subscription';
// import { debounceTime, switchMap } from 'rxjs/operators';
// import { asyncScheduler } from 'rxjs';
import { MediaDialogContent } from './MediaDialogContent_v2';
import { ContentMedia } from '@lib/company';
import { rbac } from '@lib/common';

export const MediaPicker = ({
  onMediaAdd = null,
  onMediaEdit = null,
  MediaEditState = false,
  editMediaScenario = false,
  editMediaIndex = null,
  editMediaData = null,
  setEachMediaEdit = null,
  company_services = null,
  company_vtr_id=null,
  isLock=null,
}: {
  onMediaAdd?: (Media: ContentMedia) => any;
  onMediaEdit?: (Media: ContentMedia, idx?: number) => any;
  MediaEditState?: boolean;
  editMediaScenario?: boolean;
  editMediaIndex?: number;
  editMediaData?: ContentMedia;
  setEachMediaEdit?: (editingBadge: boolean) => any;
  company_services?: any;
  company_vtr_id?: any;
  isLock?:any;
}) => {
  const [dialogOpen, openDialog, closeDialog] = useBoolean(false);
  useEffect(() => {
    if (MediaEditState) openDialog();
  }, [MediaEditState]);

  const saveMediaClick = (Media: ContentMedia) => {
    closeDialog();
    setTimeout(() => {
      if (editMediaScenario)
        onMediaEdit &&
          onMediaEdit(
            {
              file_name: Media.file_name,
              associated_services: Media.associated_services,
              associated_projects: Media.associated_projects,
              media_url: Media.media_url,
              media_type: Media.media_type,
              vtr_id: Media.vtr_id,
              attach_b64: Media.attach_b64,
              media_caption: Media.caption,
              media_title: Media.caption,
              original_media_vtr_id: Media.original_media_vtr_id,
              order_id: Media.order_id
            },
            editMediaIndex
          );
      else
        onMediaAdd &&
          onMediaAdd({
            file_name: Media.file_name,
            associated_services: Media.associated_services,
            associated_projects: Media.associated_projects,
            media_url: Media.media_url,
            media_type: Media.media_type,
            vtr_id: Media.vtr_id,
            attach_b64: Media.attach_b64,
            media_caption: Media.caption,
            media_title: Media.caption,
            original_media_vtr_id: Media.original_media_vtr_id
          });
      setOkPressed(false);
    }, 100);
  };
  
  const [OkPressed, setOkPressed] = useState(false);
  return (
    <>
      {!editMediaScenario && (
        <Button
          onClick={openDialog}
          disabled={true}
          // {rbac('Content_AddContentMedia', '', 'Button') || isLock}
          color="primary"
          variant="contained">
          Add
        </Button>
      )}
      <Dialog
        // Disable transitions to speed up the element interaction
        // and fix multiple addtion on consecutive clicks.
        transitionDuration={0}
        fullWidth
        maxWidth="sm"
        open={dialogOpen}
        onClose={() => {
          setEachMediaEdit && setEachMediaEdit(false);
          closeDialog();
        }}>
        <DialogTitle>Add/Edit Media</DialogTitle>
        <DialogContent style={{ height: '65vh' }} dividers>
          <MediaDialogContent
            saveMedia={saveMediaClick}
            defaultValue={editMediaData}
            OkPressed={OkPressed}
            setOkPressed={setOkPressed}
            company_services={company_services}
            company_vtr_id={company_vtr_id}
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOkPressed(true)}>Ok</Button>
          <Button
            onClick={() => {
              setEachMediaEdit && setEachMediaEdit(false);
              closeDialog();
            }}>
            Cancel
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};
